import { ApiKeysGridView } from '~/components/system/api-keys';
import { PageContainer } from '~/components/page-container';

export function ApiKeys() {
	return (
		<PageContainer>
			<ApiKeysGridView />
		</PageContainer>
	);
}
